<!-- /* [NT-APPLY-COM-POP] 기업매칭신청 */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="onClose"
      disabledFooter
      title="NAP 자문 신청하기"
      v-if="data"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <CorpInfoCard :data="data" />

        <h6
          class="popupViewProfileHeadline"
          style="padding-bottom: 0px !important;"
        >
          매칭 프로세스
        </h6>
        <section class="flex statusMatchingRow">
          <div
            class="statusMatchingItem"
            v-for="(item, index) in statusMatchingItems"
            :key="index"
            :style="{ backgroundColor: item.bgColor }"
          >
            <figure class="image">
              <img :src="item.img" :alt="item.title" />
            </figure>
            <div class="itemText">
              <div style="display: flex; justify-content: center;">
                <div class="itemTextIcon">
                  <figure>
                    <img :src="item.icon" :alt="item.title" />
                  </figure>
                  <h6>프로필 작성</h6>
                </div>
              </div>
              <h6 class="itemTextDesc">
                다른 기업들에게 보여질 소중한 기업정보를 입력해주세요.
              </h6>
            </div>
          </div>
        </section>

        <section>
          <h3 class="matchingHeadLine">신청서 작성</h3>
          <ValidationObserver v-slot="{ handleSubmit }" class="aRow5">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickSubmitForm)"
            >
              <div style="margin-bottom: 50px;">
                <InputField label="신청 대상 기업" v-model="data.name" />
                <ValidationProvider
                  name="매칭신청 사유"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="매칭신청 사유"
                    v-model="form.application"
                    :errors="errors"
                  />
                </ValidationProvider>

                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">
                  연락처 정보
                  <span style="color: #FF0000; font-size: 1.6rem;"
                    >*신청자가 다를 경우에는 수정하십시오.</span
                  >
                </h3>
                <InputField label="신청자 이름" v-model="user.name" />
                <InputField label="이메일 주소" v-model="user.email" />
                <InputField label="전화번호" v-model="user.phoneNumber" />
                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">NAP 자문 요청</h3>
                <ValidationProvider
                  name="NAP 자문 요청 사항"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="NAP 자문 요청 사항"
                    v-model="form.question"
                    :errors="errors"
                  />
                </ValidationProvider>
              </div>
              <div class="mainModalFooter">
                <MainButton
                  btnText="자문서 전송"
                  color="green"
                  type="submit"
                  :disabled="disabledSubmit"
                />
              </div>

              <!-- <button type="submit" class="btnFont redBtn">다 음</button> -->
            </form>
          </ValidationObserver>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import axios from "@/axios/axios";
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import InputField from "@/components/formControl/InputField.vue";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";

export default {
  name: "NTApplyNAPPopup",
  components: {
    BasicModal,
    MainButton,
    ValidationObserver,
    ValidationProvider,
    TextAreaInputField,
    InputField,
    CorpInfoCard,
  },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    data: Object,
  },
  data() {
    return {
      disabledSubmit: false,
      user: this.$store.state.auth.user,
      form: {
        requesterIdx: this.$store.state.auth.user.idx,
        requestedIdx: 2,
        application: "",
        question: "",
      },
      statusMatchingItems: [
        {
          id: 1,
          title: "총 신청 수",
          number: "1423 건",
          img: "/images/myPage/matching1.svg",
          icon: "/images/myPage/docs.svg",
          bgColor: "#FFFDEE",
          textColor: "#26336A",
        },
        {
          id: 1,
          title: "매칭 대기",
          number: "123 건",
          img: "/images/myPage/matching2.svg",
          icon: "/images/myPage/search.svg",
          bgColor: "#FFFCDF",
          textColor: "#3F7416",
        },
        {
          id: 1,
          title: "매칭 완료",
          number: "1423 건",
          img: "/images/myPage/matching3.svg",
          icon: "/images/myPage/chat.svg",
          textColor: "#2B939A",
          bgColor: "#FFFACD",
        },
        {
          id: 1,
          title: "매칭 거절",
          number: "1423 건",
          img: "/images/myPage/matching4.svg",
          icon: "/images/myPage/hand.svg",
          textColor: "#BD4444",
          bgColor: "#FFF499",
        },
      ],
    };
  },
  watch: {
    data() {},
    isModal(val) {
      if (!val)
        this.form = {
          requesterIdx: this.$store.state.auth.user.idx,
        };
    },
  },
  methods: {
    onClickSubmitForm() {
      const that = this;
      this.disabledSubmit = true;
      if (this.data && this.data.idx) {
        const params =
          "requesterIdx=" +
          this.form.requesterIdx +
          "&requestedIdx=" +
          this.data.idx +
          "&application=" +
          this.form.application +
          "&question=" +
          this.form.question;
        axios
          .post("/api/matching/nap/create?" + params)
          .then((response) => {
            if (response.status == 200) {
              that.onClose();
              that.$alert("알림", "제출해주셔서 감사합니다");
              // if (this.user.roleName == "ROLE_CORP") {
              //   this.$router.push("/crop/myMatchingStatusSent");
              // } else {
              //   this.$router.push("/user/myMatchingStatusSent");
              // }
            }
          })
          .catch((error) => {
            console.log("response: ");
            console.log("error: " + error);
            return [];
          })
          .finally(() => {
            that.disabledSubmit = false;
          });
      }
    },
    gotoHome(link) {
      window.open(link, "_blank");
    },
    onClose() {
      this.form.application = "";
      this.form.question = "";
      this.handleToggleModal();
    },
  },
};
</script>

<style lang="scss" scoped></style>
